module.exports = __webpack_public_path__ + "static/media/CentroEnsinoSaber_Logo.219bd67e.svg";